var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCard = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40"
}, props), /*#__PURE__*/React.createElement("mask", {
  id: "card_svg__a",
  width: 40,
  height: 40,
  x: 0,
  y: 0,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "alpha"
  }
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M0 0h40v40H0z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#card_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M36.667 10v20a3.21 3.21 0 0 1-.98 2.354 3.21 3.21 0 0 1-2.354.98H6.667a3.21 3.21 0 0 1-2.354-.98A3.21 3.21 0 0 1 3.333 30V10c0-.917.327-1.701.98-2.354a3.21 3.21 0 0 1 2.354-.98h26.666a3.21 3.21 0 0 1 2.355.98A3.21 3.21 0 0 1 36.666 10Zm-30 3.333h26.666V10H6.667v3.333Zm0 6.667v10h26.666V20H6.667Z"
}))));
export default SvgCard;